// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2LMPw","header":"MergedInvoice_header__1V2q1"};